import { AlertDialog, Button, Flex, VisuallyHidden } from '@radix-ui/themes';

interface ConfirmAlertDialogProps<T> {
    disabledConfirm?: boolean;
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title: string;
    item: T | null;
    onConfirm: (item: T) => void;
    onCancel: () => void;
    descriptionComponent?: React.ReactNode;
    /** Texto descritivo anunciado por leitores de ecrã e mostrado ao utilizador. */
    description?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    confirmColor?: 'red' | 'green' | 'blue' | 'gray';
}

export const ConfirmAlertDialog = <T,>({
    open,
    onOpenChange,
    title,
    item,
    onConfirm,
    onCancel,
    disabledConfirm = false,
    descriptionComponent,
    description,
    confirmLabel = 'Continuar',
    cancelLabel = 'Cancelar',
    confirmColor = 'red',
}: ConfirmAlertDialogProps<T>) => {
    return (
        <AlertDialog.Root open={open} onOpenChange={onOpenChange}>
            <AlertDialog.Content maxWidth="450px">
                <AlertDialog.Title>{title}</AlertDialog.Title>

                {/* O Radix exige uma descrição para anunciar o diálogo; quando não
                    há texto, mantemo-la acessível mas invisível. */}
                {description ? (
                    <AlertDialog.Description size="2">{description}</AlertDialog.Description>
                ) : (
                    <VisuallyHidden>
                        <AlertDialog.Description>{title}</AlertDialog.Description>
                    </VisuallyHidden>
                )}

                <Flex direction="column" gap="3" mt="4">
                    {descriptionComponent}

                    <Flex gap="3" justify="end" mt="2">
                        <AlertDialog.Cancel>
                            <Button variant="soft" color="gray" onClick={onCancel}>
                                {cancelLabel}
                            </Button>
                        </AlertDialog.Cancel>
                        <AlertDialog.Action disabled={disabledConfirm}>
                            <Button
                                variant="solid"
                                color={confirmColor}
                                disabled={disabledConfirm}
                                onClick={() => item && onConfirm(item)}
                            >
                                {confirmLabel}
                            </Button>
                        </AlertDialog.Action>
                    </Flex>
                </Flex>
            </AlertDialog.Content>
        </AlertDialog.Root>
    );
};
